module.exports = __webpack_public_path__ + "img/1.9fd49829.png";